import { render, staticRenderFns } from "./newCorso.vue?vue&type=template&id=e4ab54a4&"
import script from "./newCorso.vue?vue&type=script&lang=js&"
export * from "./newCorso.vue?vue&type=script&lang=js&"
import style0 from "./newCorso.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports